import { Table, Input, Space, Button, Checkbox, Form, List } from "antd";
import React, { useState, useRef, useEffect } from "react";
import {
  UploadOutlined,
  PrinterOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { IntToBetrag } from "../Helper/ZahlenFormat";
import { retry } from "@reduxjs/toolkit/query";
import { getSaldenArray } from "../Helper/PrKontoHelper";

export const KontenDatenDetails = ({ kontoData }) => {
  console.log("XXX handleOnEditclick", kontoData);
  const [dataSource, setDataSource] = useState();

  useEffect(() => {
    const daten = getSaldenArray(kontoData).map((item) => {
      return {
        key: item.index,
        soll: item.soll,
        haben: item.haben,
      };
    });
    if (kontoData.bilanzopen > 0) {daten[0].soll += kontoData.bilanzopen;daten[1].soll -= kontoData.bilanzopen};
    if (kontoData.bilanzopen < 0) {daten[0].haben -= kontoData.bilanzopen;daten[1].haben += kontoData.bilanzopen};

    if (kontoData.bilanzclose > 0) {daten[12].soll -= kontoData.bilanzclose};
    if (kontoData.bilanzclose < 0) {daten[12].haben += kontoData.bilanzclose};

    let summeSoll = 0;
    let summeHaben = 0;
    daten.forEach((transaktion) => {
      summeSoll += transaktion.soll;
      summeHaben += transaktion.haben;
    });
    if ((summeSoll - summeHaben)>0) {
      summeSoll = summeSoll - summeHaben;
      summeHaben = 0;
    } else {
      summeHaben = summeHaben-summeSoll;
      summeSoll = 0;
    }

    daten.push({
      key: "Saldo",
      soll: summeHaben,
      haben: summeSoll,
    });

    console.log("daten", daten);
    setDataSource(daten);
  }, [kontoData]);

  const getColumns = () => {
    return [
      {
        title: "Monat",
        dataIndex: "key",
        key: "Monat",
        render: (text, record) => (
          <>{record.key === 0 ? <>Vortrag</> : <b>{text}</b>}</>
        ),
      },
      {
        title: "Soll",
        dataIndex: "soll",
        key: "soll",
        align: "right",
        render: (text) => <>{IntToBetrag(text)}</>,
      },
      {
        title: "Haben",
        dataIndex: "haben",
        key: "haben",
        align: "right",
        render: (text) => <>{IntToBetrag(text)}</>,
      },
    ];
  };

  return (
    <>
      <Table
        size={"small"}
        dataSource={dataSource}
        columns={getColumns()}
        pagination={false}
      />
    </>
  );
};
